module.exports = __webpack_public_path__ + "img/鎏金面膜+珍银面膜_01.f99af6c9.jpg";